import {IdentityNavigation} from '../../services/impersonation/identity-navigation';
import {STORAGE_KEY} from '../../enums/storage_keys.enum';
import {ImpersonationResponse} from '../../models/impersonation.model';
import { HttpInterceptorFn } from '@angular/common/http';
import {environment} from "../../../environments/environment";
import {inject} from "@angular/core";
import {from, switchMap, throwError} from "rxjs";
import {StorageService} from "../../services/storage/storage";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const apiUrl: string = environment.apiBaseUrl.replace(/\/$/, '');

  if (!request.url.startsWith(apiUrl)) {
    return next(request);
  }

  const apiRequest = request.clone({
    setHeaders: {
      Accept: 'application/json',
    },
  });

  const skipAuth =
    request.url.includes('/login') ||
    request.url.includes('/register') ||
    request.url.includes('/refresh') ||
    request.url.includes('/assets/i18n');

  if (skipAuth || apiRequest.headers.has('Authorization')) {
    return next(apiRequest);
  }

  const identityNavigation = inject(IdentityNavigation);
  if (identityNavigation.switching()) return throwError(() => new Error('The authenticated identity is changing.'));
  const storageService: StorageService = inject(StorageService)
  return from(Promise.all([storageService.get<string>(STORAGE_KEY.TOKEN), storageService.get<ImpersonationResponse>(STORAGE_KEY.IMPERSONATION)])).pipe(
    switchMap(([normalToken, state]) => {
      if (identityNavigation.switching()) return throwError(() => new Error('The authenticated identity is changing.'));
      const token = state?.token ?? normalToken;
      if (!token) {
        return next(apiRequest);
      }

      return next(
        apiRequest.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        })
      );
    })
  );
};
